var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 37 18", fill: "none" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.485 0l-6.6 17.07 2.33.817 6.6-17.07L20.486 0zM8.683.028L0 9.413l8.793 8.447 1.83-1.903-6.926-6.653L10.62 1.82 8.684.03zm19.33 0l8.683 9.385-8.793 8.447-1.83-1.903L33 9.304 26.074 1.82 28.013.03z", fill: "#354147" })
  );
});